/**
 * The loading state shown at the domain root while a returning user's session
 * is still resolving.
 *
 * Deliberately identical to `ProtectedRoute`'s loading state, and to the
 * markup `@fias/site-snapshot` bakes into the prerendered shell. Three
 * surfaces render this same indicator in sequence on a cold load — the
 * snapshot's pre-JS splash, this component once React mounts, and
 * `ProtectedRoute` on the destination route — so any visual difference between
 * them would read as its own flash, which is the bug this whole path exists to
 * fix. Change one, change all three.
 */
export function BootSplash() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto" />
        <p className="mt-4 text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}
